export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13133.81909f5d.jpg";